import React, { useEffect } from 'react';
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import styles from '../pa_checklist_followup.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { toBrDateWithTime } from '../../../../utils/dateUtils';
import TabInfoComp from './tinyComps/tab_info_tab_comp';
import ImageWithModal from './tinyComps/image_with_modal';

const PAChecklistFollowUpProvaTab = () => {
  const { itemSelecionado, infoComp } = usePAChecklistFollowUp();

  useEffect(() => {

  }, [itemSelecionado]);

  const dirColumns = [
    { name: 'Localização', selector: row => row.descricao_localizacao },
    { name: 'Defeito', selector: row => row.descricao_defeito }
  ];

  return (
    <section className={styles.inner_tab_wrapper}>
      {
        !itemSelecionado.resultadoProvaDeRoupa &&
        <div className={styles.no_data_message}>Prova de roupa ainda não realizada</div>
      }
      {
        itemSelecionado.resultadoProvaDeRoupa &&
        <>
          <TabInfoComp />

          <div className={styles.separator} />

          {
            itemSelecionado.defeitosProvaDeRoupa.length === 0 &&
            <div className={styles.section_label}>Nenhum defeito inserido</div>
          }

          {
            itemSelecionado.defeitosProvaDeRoupa.length > 0 &&
            <div>
              <div className={styles.section_label}>Defeitos</div>
              <Tabela
                columns={dirColumns}
                data={itemSelecionado.defeitosProvaDeRoupa}
                pagination={false}
                highlightOnHover={true}
              />
            </div>
          }

          <div className={styles.separator} />

          {
            itemSelecionado.resChecklistImagensProva.length === 0 &&
            <div className={styles.section_label}>Nenhuma imagem inserida</div>
          }

          {
            itemSelecionado.resChecklistImagensProva.length > 0 &&
            <div>
              <div className={styles.section_label}>Imagens</div>
              <section className={styles.flex_row_wrapper}>
                {itemSelecionado.resChecklistImagensProva.map((src, i) => {
                  return <ImageWithModal key={i} src={src} i={i} />
                })}
              </section>
            </div>
          }
        </>
      }
    </section>
  );
}

export default PAChecklistFollowUpProvaTab;
